import { useForm } from 'react-hook-form';

// biome-ignore lint/suspicious/noExplicitAny: inherited from operator
export const useHookForm = (defaultValues?: any) => {
    const { register, formState, reset, control, setValue, getValues } =
        useForm({
            defaultValues,
            mode: 'onChange',
        });

    return {
        register,
        reset,
        formState,
        control,
        setValue,
        getValues,
    };
};
